import {white} from 'material-ui/styles/colors';
import {typography} from 'material-ui/styles';

const styles = {
    container: {
        height: 40,
        lineHeight: "40px",
        bottom: 0,
        backgroundColor: white,
        position: "fixed",
        width: "100%",
        textAlign: "center",
        zIndex: 999
    },
    text: {
        fontSize: 13,
        fontWeight: typography.fontWeightLight,
        paddingBottom: 5
    },
    footerSpace: {
        height: 60
    }
};

export default styles;



// WEBPACK FOOTER //
// src/components/common/Footer/Footer.css.js